import { render, staticRenderFns } from "./myPrice.vue?vue&type=template&id=2f5d193a&scoped=true&"
import script from "./myPrice.vue?vue&type=script&lang=js&"
export * from "./myPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5d193a",
  null
  
)

export default component.exports